import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'session-timeout-page',
  templateUrl: './session-timeout-page.component.html',
  styleUrls: ['./session-timeout-page.component.scss']
})
export class SessionTimeoutPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
